import { Location } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JoinStateDetails } from '@app/app/shared/models';
import { RestClientService } from '@app/app/shared/services/rest-client.service';
import { ObservableResult } from '@app/app/shared/store';
import { environment } from '@app/environments/environment';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { JoinAction, JoinDataService, JoinTarget } from './join-data.service';

const PATHS: Record<JoinAction, string> = {
  ENROL: 'enrolment',
  REGISTER: 'registration',
  WITHDRAW: 'enrolment',
  ACCEPT_SEAT: 'seat-offer/accept',
  DECLINE_SEAT: 'seat-offer/decline',
  ACCEPT_INVITATION: 'invitation/accept',
  DECLINE_INVITATION: 'invitation/decline',
};

@Injectable()
export class ApiJoinDataService implements JoinDataService {
  constructor(private client: RestClientService) {}

  act(target: JoinTarget, action: JoinAction): ObservableResult<JoinStateDetails> {
    // Learners reach a card's join actions under its progress: the other card paths are for its admins.
    const base = target.kind === 'playlist' ? `playlists/${target.uid}` : `cards/${target.id}/progress`;
    const url = Location.joinWithSlash(environment.apiRootUrl || '', `${base}/${PATHS[action]}`);
    const params = target.kind === 'playlist' && target.in ? { in: target.in } : undefined;
    const request: Observable<HttpResponse<JoinStateDetails>> =
      action === 'WITHDRAW' ? this.client.delete<JoinStateDetails>(url, params) : this.client.post<JoinStateDetails>(url, null, params);
    return request.pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError((err: HttpErrorResponse) => ObservableResult.ofError(err?.error?.message ?? '')),
    );
  }
}
